import { useState } from 'react';
import { useFiltreBarYuvasi, FiltreBarPortal } from '../components/FiltreBarYuvasi';
import { useStokKaynaklari } from '../components/stok-analiz/ekranKaynaklari';
import { useStokFiltre } from '../components/stok-analiz/useStokFiltre';
import { StokFiltreSeridi } from '../components/stok-analiz/StokFiltreSeridi';
import { OzetSerit } from '../components/stok-analiz/OzetSerit';
import { KayipBlok } from '../components/stok-analiz/KayipBlok';
import { SermayeBlok } from '../components/stok-analiz/SermayeBlok';
import { AkisBlok } from '../components/stok-analiz/AkisBlok';
import { StokDetayModal } from '../components/stok-analiz/detay/StokDetayModal';
import type { StokDetay } from '../components/stok-analiz/detay/stokDetayTipleri';
import type { EkranProps } from '../ekranKayitDefteri';

/**
 * G4b/C4b — Stok Analizi sayfa KOMPOZİSYONU: filtre şeridi (B1'in kabuğu, artık `StokFiltreSeridi` ile
 * dolu — dönem/şube/kategori/özel aralık) + ÖZET ŞERİT + KAYIP + SIKIŞAN SERMAYE + AKIŞ (spec §4 sırası)
 * + detay modalı. Filtre barı deseni `pages/SatisAnaliz.tsx:41,56-71`'den birebir: yuva varsa portal,
 * yoksa sayfa içi yapışık şerit (B1'den değişmedi).
 *
 * Modal durumu SAYFADA tutulur (`useState<StokDetay | null>`), bloklar yalnız `ac` ile "hangi detay"
 * bildirir — SA'nın K7 kalıbıyla aynı. AKIŞ bloğu `StokDetay` üretmez (990047 TiklaAc ile tembel,
 * kendi içinde iki uçtan liste gösterir — drill-down modalı yok, C4a kararı) — bu yüzden `ac` almaz.
 */
export default function StokAnalizi({ screen }: EkranProps) {
  const kaynaklar = useStokKaynaklari(screen);
  const filtre = useStokFiltre();
  const { hedef } = useFiltreBarYuvasi();
  const [detay, setDetay] = useState<StokDetay | null>(null);

  const serit = <StokFiltreSeridi filtre={filtre} kaynaklar={kaynaklar} />;

  return (
    <div className="flex flex-col gap-4">
      {hedef !== null ? (
        <FiltreBarPortal>
          <div
            data-testid="stok-filtre-bar"
            className="bg-surface border-b border-border shadow-[0_1px_3px_rgb(16_33_92/0.06)]"
          >
            <div className="mx-auto w-full max-w-[1400px] px-4 md:px-6 py-2.5">{serit}</div>
          </div>
        </FiltreBarPortal>
      ) : (
        <div data-testid="stok-filtre-seridi-dar" className="sticky top-0 z-10 bg-page py-2">
          {serit}
        </div>
      )}

      <div data-testid="stok-analiz-sayfa" className="flex flex-col gap-4">
        <OzetSerit
          kaynaklar={kaynaklar}
          donem={filtre.donem}
          oncekiDonem={filtre.oncekiDonem}
          sube={filtre.sube}
          kategori={filtre.kategori}
        />
        <KayipBlok
          kaynaklar={kaynaklar}
          donem={filtre.donem}
          sube={filtre.sube}
          kategori={filtre.kategori}
          ac={setDetay}
        />
        <SermayeBlok
          kaynaklar={kaynaklar}
          donem={filtre.donem}
          sube={filtre.sube}
          ac={setDetay}
        />
        <AkisBlok kaynaklar={kaynaklar} donem={filtre.donem} sube={filtre.sube} />
      </div>

      <StokDetayModal
        detay={detay}
        onKapat={() => setDetay(null)}
        kaynaklar={kaynaklar}
        donem={filtre.donem}
        sube={filtre.sube}
        kategori={filtre.kategori}
      />
    </div>
  );
}
